import {PlacesOfInteractionType} from '@optimaxdev/analytics/desktop/types/placeOfInteraction';

import {ApplicationStoreType} from 'desktop/store';

/**
 * get place for interaction from store
 * @param {ApplicationStoreType} store - Application store type.
 * @returns {string} - name of place interaction
 */
export const getPlaceOfInteraction = (store: ApplicationStoreType): PlacesOfInteractionType =>
    store.cart.placeOfInteraction;
